<template>
  <div class="modal-card has-text-centered" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Detalle kit {{ item.articulo.id }}</p>
      <button type="button" class="delete" @click="closeModalHandle" />
    </header>
    <section class="modal-card-body">
      <div>
        <p>
          Detalle de los art&iacute;culos que componen el kit: <br />
          <strong>{{ item.articulo.descripcion }}</strong>
        </p>
        <div class="pt-3 columns">
          <div class="column">
            <table
              class="table is-fullwidth is-striped is-hoverable is-bordered"
            >
              <thead>
                <tr>
                  <th>Art&iacute;culo</th>
                  <th>Descripci&oacute;n</th>
                  <th class="has-text-centered">U.Medida</th>
                  <th class="has-text-right">Stock</th>
                  <th class="has-text-right">Facturado</th>
                  <th class="has-text-right">A Entregar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="parte in item.partes" :key="`parte-kit-${parte.id}`">
                  <td class="has-text-centered">{{ parte.articulo.id }}</td>
                  <td class="has-text-left">
                    {{ parte.articulo.descripcion }}
                  </td>
                  <td class="has-text-centered">{{ parte.unidadMedida }}</td>
                  <td class="has-text-right">{{ parte.stock }}</td>
                  <td class="has-text-right">{{ parte.cantidadFacturada }}</td>
                  <td class="has-text-right">
                    {{
                      (parte.cantidadFacturada / item.cantidadFacturada) *
                      item.cantidadEntregada
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button label="Cerrar" type="is-success" @click="closeModalHandle" />
    </footer>
  </div>
</template>

<script>
export default {
  name: 'DetalleKitModal',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    closeModalHandle() {
      this.$emit('close')
    }
  }
}
</script>
